export const defaultMenu = [
  {
    id: 1,
    name: "Аджапсандал",
    price: "640",
    weight: "150 г",
    image: "https://eda.yandex.ru/images/3702558/bb0e5c46efe64b31a3007844cc4acc32-300x300.jpeg",
    description: "Традиционная грузинская закуска из баклажанов, перцев и помидоров с ароматными специями",
    category: "cold"
  },
  {
    id: 2,
    name: "Ассорти из зелени",
    price: "490", 
    weight: "200 г",
    image: "https://eda.yandex.ru/images/3337779/3c19dc4fd58a44e9ac8f63cbe2da294e-324x282.jpeg",
    description: "Свежее ассорти из сезонной зелени с грузинскими соусами",
    category: "cold"
  },
  {
    id: 3,
    name: "Пхали из шпината",
    price: "590",
    weight: "300 г",
    image: "https://eda.yandex.ru/images/3596693/ab53875daf4849f18e86918aaf3d670c-324x282.jpeg", 
    description: "Пхали из шпината и других овощей с грецкими орехами",
    category: "cold"
  },
  {
    id: 4,
    name: "Салат Имеретинский",
    price: "560",
    weight: "250 г",
    image: "https://eda.yandex.ru/images/3502800/9d5956cc41b6412583688d59c0ae7333-300x300.jpeg",
    description: "Традиционный грузинский салат с сыром сулугуни и зеленью",
    category: "salads"
  },
  {
    id: 5,
    name: "Салат Моцарелла с помидорами", 
    price: "590",
    weight: "250 г",
    image: "https://eda.yandex.ru/images/3504598/e7e35da6fe8943fa812eff28578c5571-300x300.jpeg",
    description: "Свежая моцарелла с помидорами и базиликом, заправленные оливковым маслом",
    category: "salads"
  },
  {
    id: 6,
    name: "Дорадо на мангале",
    price: "1120",
    weight: "230 г", 
    image: "https://eda.yandex.ru/images/3512182/cc97331c635246648b0e53ee5fa3e9e6-300x300.jpeg",
    description: "Приготовленная на гриле дорадо с овощами и лимоном",
    category: "hot"
  },
  {
    id: 7,
    name: "Жареный сыр сулугуни",
    price: "578",
    weight: "200 г",
    image: "https://eda.yandex.ru/images/3667559/ce3ebd5a5f0f4480891c2a046cbf3e29-300x300.jpeg", 
    description: "Вкусный жареный сыр сулугуни с мятой и гранатом",
    category: "hot"
  },
  {
    id: 8,
    name: "Долма",
    price: "527",
    weight: "250 г",
    image: "https://eda.yandex.ru/images/3507285/f44be70f63fe4b3f8ccf29fa9f68e889-300x300.jpeg",
    description: "Грузинская долма в виноградных листьях с мясной начинкой",
    category: "hot"
  },
  {
    id: 9,
    name: "Хачапури по-аджарски",
    price: "690",
    weight: "350 г",
    image: "https://cdn.culture.ru/images/baace039-8e29-578d-9bcf-99203979b7f7",
    description: "Традиционная грузинская лепешка с сыром и яйцом",
    category: "hot"
  },
  {
    id: 10,
    name: "Borjomi",
    price: "420",
    weight: "500 мл", 
    image: "https://eda.yandex.ru/images/3531870/0b22db6aa5e044faad85758ea4fa835f-300x300.jpeg",
    description: "Легендарная грузинская минеральная вода из одноименного источника",
    category: "drinks"
  },
  {
    id: 11,
    name: "Фанта",
    price: "380",
    weight: "500 мл",
    image: "https://eda.yandex.ru/images/3806315/63e8b0ecbde242fd9048bf810ed73343-300x300.jpeg",
    description: "Грузинский лимонад с натуральными соками",
    category: "drinks"
  }
];